import { cva, type VariantProps } from "class-variance-authority";
import { StarIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Badge } from "./badge";

const proBadgeVariants = cva(
  "gap-1.5 rounded-md border-0 bg-gradient-to-br from-yellow-600 to-yellow-800 font-semibold text-white uppercase tracking-wide shadow-md",
  {
    variants: {
      size: {
        default:
          "px-2 py-0.5 text-[0.725rem] leading-4 [&>svg]:h-3 [&>svg]:w-3",
        md: "px-2.5 py-1 text-sm [&>svg]:h-3.5 [&>svg]:w-3.5",
      },
    },
    defaultVariants: {
      size: "default",
    },
  }
);

interface ProBadgeProps extends VariantProps<typeof proBadgeVariants> {
  className?: string;
}

export function ProBadge({ className, size }: ProBadgeProps) {
  return (
    <Badge
      className={cn(proBadgeVariants({ size }), className)}
      variant="outline"
    >
      <StarIcon className="fill-current" />
      <span>Pro</span>
    </Badge>
  );
}
